import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconVerticalDots = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconVerticalDots"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M12.006 6a3 3 0 0 1-2.772-1.852A3 3 0 0 1 11.42.058a3 3 0 0 1 3.08 1.276c.33.493.506 1.073.506 1.666a3.005 3.005 0 0 1-3 3m0 9a3 3 0 0 1-2.772-1.852 3 3 0 0 1 2.186-4.09 3 3 0 0 1 3.08 1.276 2.997 2.997 0 0 1-2.494 4.664zm0 9a3 3 0 0 1-2.772-1.852 3 3 0 0 1 2.186-4.09 3 3 0 0 1 3.08 1.276c.33.493.506 1.073.506 1.666a3.005 3.005 0 0 1-3 3" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconVerticalDots);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
